<div class="m-2">

    <mat-card class="mt-4">
        <mat-card-content>
            <!-- State display component -->
            <app-state-display
                *ngIf="showStateDisplay"
                [type]="stateType"
                loadingMessage="Loading calls..."
                emptyMessage="No calls scheduled"
                [errorMessage]="errorMessage || 'Failed to load calls'"
                emptyIcon="phone"
                errorIcon="error_outline">
            </app-state-display>

            <!-- Calls table -->
            <table mat-table [dataSource]="dataSourceApplicationCalls" *ngIf="showTable">
                <ng-container matColumnDef="applicant">
                    <th mat-header-cell *matHeaderCellDef>Applicant</th>
                    <td mat-cell *matCellDef="let call">{{ Applicant.toDisplayText(call.applicant) }}</td>
                </ng-container>
                <ng-container matColumnDef="subject">
                    <th mat-header-cell *matHeaderCellDef>Subject</th>
                    <td mat-cell *matCellDef="let call">{{ call.subject }}</td>
                </ng-container>
                <ng-container matColumnDef="purpose">
                    <th mat-header-cell *matHeaderCellDef>Purpose</th>
                    <td mat-cell *matCellDef="let call">{{ ApplicationCallPurpose.toDisplayText(call.purpose) }}</td>
                </ng-container>
                <ng-container matColumnDef="dateTime">
                    <th mat-header-cell *matHeaderCellDef>Start time</th>
                    <td mat-cell *matCellDef="let call">{{ DateUtil.formatDate(call.dateTime) }}</td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Call status</th>
                    <td mat-cell *matCellDef="let call">{{ ApplicationCallStatus.toDisplayText(call.status) }}</td>
                </ng-container>
                <ng-container matColumnDef="ownedBy">
                    <th mat-header-cell *matHeaderCellDef>Owned by</th>
                    <td mat-cell *matCellDef="let call">{{ call.ownedByEmployee.name }}</td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let call;index as i;">
                        <button mat-icon-button (click)="completeCall(call); $event.stopPropagation()" matTooltip="Complete">
                            <mat-icon>check_circle</mat-icon>
                        </button>
                        <button mat-icon-button (click)="cancelCall(call); $event.stopPropagation()" matTooltip="Cancel">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsApplicationCalls"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsApplicationCalls" (click)="onClicked(row)" class="clickable-row"></tr>
            </table>
        </mat-card-content>
    </mat-card>
</div>
